import { useState } from "react";
import {
  formatCompactNumber,
  formatRepoName,
  getLanguageColor,
} from "../helpers/helpers";

const ProjectCard = ({ repo }) => {
  const [hasImageError, setHasImageError] = useState(false);

  const displayName = formatRepoName(repo.displayName || repo.name);

  return (
    <article className="project-card glass-card">
      {repo.imageURL && !hasImageError ? (
        <img
          className="project-preview"
          src={repo.imageURL}
          alt={`${displayName} preview`}
          onError={() => setHasImageError(true)}
        />
      ) : (
        <div className="project-preview project-preview-fallback">
          <span className="material-symbols-outlined">data_object</span>
        </div>
      )}

      <div className="project-content">
        <div className="project-metrics">
          <span>Stars: {formatCompactNumber(repo.stargazers_count)}</span>
          <span>Forks: {formatCompactNumber(repo.forks_count)}</span>
        </div>

        <h3>{displayName}</h3>
        <p>{repo.description}</p>

        <div className="project-footer">
          <span className="language-pill">
            <span
              className="language-dot"
              style={{ backgroundColor: getLanguageColor(repo.language) }}
            />
            {repo.language}
          </span>
          <a href={repo.html_url} target="_blank" rel="noreferrer">
            View Repo
          </a>
        </div>
      </div>
    </article>
  );
};

export default ProjectCard;

